import React from "react";
import { getAwsAssets } from "@src/utils";
import styles from "../../../styles/DownloadCompletedIcon.module.scss";
import { Image } from "@src/components/Image";
import { t } from "i18next";

const DownloadCompletedIcon = ({ isTextVisible = false }) => {
  return (
    <div className={`${styles.downloadCompletedIcon} ${isTextVisible ? styles.downloadCompletedIconwithText : ""}`}>
      <div className={styles.downloadCompletedIcon__icon}>
        <Image
          src={getAwsAssets("checkIcon.svg", "content")}
          alt="checkIcon"
          height={8}
          width={7}
        />
      </div>
     {isTextVisible && <span className={styles.downloadCompletedIcon__text}>{t(
        "components.tabs.content.components.contentList.listItem.downloadCompletedText",
        "Downloaded"
      )}</span>}
    </div>
  );
};

export default DownloadCompletedIcon;
